/**
 * Modal object for creating modals.
 *
 * @usage:
 *
 * 	var myModal = new Modal( element, { 'open' : true, 'onOpen' : myFunction );
 *
 * 	Assumes html like:
 *
 *  	<div class="modal">
 *  		<!-- a 'modal' can have more than one 'modal__box'es. -->
 *  		<div class="modal__box" >
 *  			<a href="#close" title="Close" class="modal__close_btn">Close</a>
 *  			<h2>A header</h2>
 *  			<p>A bunch of random text here. A bunch of random text here. And some more!</p>
 *  			<a href="#close" title="Close" class="modal__button" data-action="close">Continue</a>
 *  		</div>
 *  	</div>
 *
 *
 * @param element - DOM element that is the container for the modal
 * @param object - object containing optional attributes using this format:
 * 		{
 *
 * 			// When set, opens modal at creation.
 * 			'open' : false,
 *
 * 			// When set, clicking outside a modal box closes the modal.
 * 			'close_on_click_away' : true,
 *
 * 			// When set, displays only once (based on a cookie).
 * 			// TODO: not yet implemented
 * 			'show_once' : false,
 *
 * 			// Function to run when opening modal
 * 			'onOpen'  : function() {},
 *
 * 			// Function to run when closing modal
 * 			'onClose' : function() {},
 *
 * 		}
 *
 * @author HGB3 12/12/2016
 */
function Modal( element, atts ) {

	// First try to use atts passed as an arg, if none were passed, try global modalAttributes.
	// Otherwise, just use an empty object
	if ( ! atts ) {
		if ( typeof modalAttributes !== 'undefined' ) {
			atts = modalAttributes;
		} else {
			atts = {};
		}
	}

	var attributes = {  // If available, use passed attributes, otherwise use defaults
		'open' : 				atts.open !== undefined ? atts.open : false,
		'close_on_click_away' : atts.close_on_click_away !== undefined ? atts.close_on_click_away : true,
		'show_once' : 			atts.show_once !== undefined ? atts.show_once : false,
		'onOpen' : 				atts.onOpen || function() {},
		'onClose' : 			atts.onClose || function() {},
	};

	if ( ! element ) {  // Sanity check
		console.warn( 'Cannot create Modal without modal element.' );
		return;
	}

	this.element = element;

	this.name = this.element.dataset.name;

	// Store a reference to the modal object on the element.
	this.element.modal = this;


	// Event Handlers

	var modal = this;  // Closure on which to attach 'this'
	var close = function() { modal.close(); };

	var closeButtons = this.element.querySelectorAll( '.modal__close_button' );
	for ( var i = 0; i < closeButtons.length; i++ ) {
		closeButtons[i].addEventListener( 'click', close );
	}

	// For all modal buttons, set up event handler for action data attribute.
	var bindModalButton = function( button ) {
		var action = button.dataset.action;
		if ( action && typeof modal[action] === 'function' ) {
			button.addEventListener( 'click', function( event ) {
				modal[action]();
				event.preventDefault();
			});
		}
	};

	var modalButtons = this.element.querySelectorAll( '.modal__button' );
	for ( var j = 0; j < modalButtons.length; j++ ) {
		bindModalButton( modalButtons[j] );
	}

	if ( attributes.close_on_click_away ) {
		// Close when clicking the element (the area around the modal)...
		this.element.addEventListener( 'click', close );

		// ...but don't allow click events to bubble up past modal boxes.
		// They should handle their own events.
		var modalBoxes = this.element.querySelectorAll( '.modal__box' );
		for ( var k = 0; k < modalBoxes.length; k++ ) {
			modalBoxes[k].addEventListener( 'click', function( event ) {
				event.stopPropagation();
			});
		}
	}

	// onOpen event handler
	this.onOpen = attributes.onOpen;

	// onClose event handler
	this.onClose = attributes.onClose;


	if ( attributes.open ) { this.open(); }
}

/**
 * Hides the modal
 *
 * Adds hide class and removes show class on modal container element.
 * Animation should be done in stylesheets.
 */
Modal.prototype.hide = function() {
	this.element.classList.add( 'hide' );
	this.element.classList.remove( 'show' );
};

/**
 * Shows the modal
 *
 * Adds show class and removes hide class on modal container element.
 * Animation should be done in stylesheets.
 */
Modal.prototype.show = function() {
	this.element.classList.add( 'show' );
	this.element.classList.remove( 'hide' );
};

/**
 * Opens the modal
 * Also runs onOpen event handler.
 */
Modal.prototype.open = function() {
	this.show();
	this.onOpen();
};

/**
 * Closes the modal
 * Also runs onClose event handler.
 */
Modal.prototype.close = function() {
	this.hide();
	this.onClose();
};

/**
 * Automatically creates a modal object for every element that has a class of
 * 'modal'.
 */
window.addEventListener( 'load', function() {

	// Store them in this array
	document.modals = [];

	var modalElements = document.querySelectorAll( '.modal' );
	for ( var i = 0; i < modalElements.length; i++ ) {
		var modalElement = modalElements[i];
		var name = modalElement.dataset.name;
		var attributes = modalElement.dataset.attributes;
		var atts;

		if (
			attributes &&
			typeof dbs !== 'undefined' &&
			dbs.modals
		) {
			atts = dbs.modals[attributes];
		}

		if ( name ) {
			document.modals[name] = new Modal( modalElement, atts );
		} else {
			document.modals.push( new Modal( modalElement, atts ) );
		}
	}

});
